module.exports = __webpack_public_path__ + "img/img31.d9dbd1dc.jpg";